import {
  API_HOST_JAVA_SET,
  API_IMG_HOST,
  SZ_API
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import VueAxios from 'vue-axios'
const axiosJavaSet = axios.create({
  baseURL: API_HOST_JAVA_SET
})
axiosJavaSet.defaults.timeout = 1000 * 15
axiosJavaSet.defaults.headers.authKey = Lockr.get('authKey')
axiosJavaSet.defaults.headers.sessionId = Lockr.get('sessionId')
axiosJavaSet.defaults.headers['Content-Type'] = 'application/json'

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = config => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) {
      // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}
// 请求处理
// axiosJavaSet.interceptors.request.use(function (config) {
//   // 在发送请求之前做些什么，例如加入token
//   // 判断当前是否是查询列表数据
//   console.log(config.url, 'config=====')
//   return config
// }, function (error) {
//   // 对请求错误做些什么
//   return Promise.reject(error)
// })
// 返回处理
axiosJavaSet.interceptors.response.use(
  function (response) {
    removePending(response) // 在一个ajax发送前执行一下取消操作
    if (response.data.code === -1) {
      // 清空登录信息
      Lockr.rm('authKey')
      Lockr.rm('sessionId')
      Lockr.rm('userInfo')
      console.log('删除了对象aet.js')
      // 跳转到登录页
      // router.push({path: '/login'})
      return response
    } else if (
      response.data.code > 101 &&
      parseInt(response.data.code) !== 200
    ) {
      if (response.data.code == 401) {
        // 跳转到登录页
        router.push({path: '/login'})
      }
      // _g.toastMsg('success', response.data.message)
      return response
    } else {
      return response
      // 处理数据为空，赋值——
      // if (response.data.code === '200') {
      //   let list = response.data.result || []
      //   let isArray = list instanceof Array
      //   if (!isArray) {
      //     // 说明不是数组
      //     list = list.list || []
      //   }
      //   if (list.length === 0) {
      //     return response
      //   } else {
      //     list.forEach(item => {
      //       for (const key in item) {
      //         if (key !== 'url' && (item[key] === '' || item[key] === null || item[key] === undefined || item[key] === 'null' || item[key] === 'undefined')) {
      //           item[key] = '—'
      //         }
      //       }
      //     })
      //     if (isArray) {
      //       response.data.result = list
      //     } else {
      //       response.data.result.list = list
      //     }
      //     let backData = {
      //       data: response.data,
      //       config: response.config,
      //       status: response.status,
      //       headers: response.headers,
      //       request: response.request,
      //       statusText: response.statusText,
      //     }
      //     console.log(backData, '正常拿到数据111')
      //     return backData
      //   }
      // } else {
      //   return response
      // }
    }
  },
  function (error) {
    return Promise.reject(error)
  }
)
// 设置-来源列表
export function getCustomerSources (pageNum, pageSize, name) {
  let url = 'customerSource/searchListByPage'
  return axiosJavaSet.get(url, {
    params: {
      pageNum,
      pageSize,
      name
    }
  })
}
// 设置-添加来源
export function addCustomerSources (name) {
  let url = 'customerSource/addCustomerSource'
  return axiosJavaSet.post(url, {
    name
  })
}
// 设置-编辑来源
export function editCustomerSources (name, id) {
  let url = 'customerSource/updataCustomerSource'
  return axiosJavaSet.put(url, {
    name,
    id
  })
}
// 设置-删除来源
export function deleteCustomerSources (id) {
  let url = 'customerSource/deletedCustomerSource'
  return axiosJavaSet.delete(url, {
    params: {
      id
    }
  })
}
// 设置-受众类型列表
export function getCusTypes (typeId) {
  let url = 'audiencesModel/searchModelList'
  return axiosJavaSet.get(url, {
    params: {
      typeId
    }
  })
}
// 设置-编辑受众类型
export function editCusTypes (name, identity, id) {
  let url = 'audiencesModel/updataUserModel'
  return axiosJavaSet.put(url, {
    name,
    identity,
    id
  })
}
// 设置-受众属性列表
export function getCusAttrList (id, isShowOrder = 0) {
  let url = 'zy/shopUserModelAttr/list/' + id + '/' + isShowOrder
  return axiosJavaSet.get(url)
}
// 设置-添加属性
export function addCustomerAttr (
  name,
  identity,
  score,
  type,
  options,
  modelId,
  required,
  cat,
  isShow,
  sort
) {
  let url = 'zy/shopUserModelAttr/add'
  return axiosJavaSet.post(url, {
    name,
    identity,
    score,
    type,
    options,
    modelId,
    required,
    cat,
    isShow,
    sort,
    isNormal: 1
  })
}
// 设置-编辑属性
export function editCustomerAttr (name, score, options, required, id, modelId) {
  let url = 'zy/shopUserModelAttr/update'
  return axiosJavaSet.put(url, {
    name,
    score,
    options,
    required,
    id,
    modelId
  })
}
// 设置-受众等级列表
export function getCusStageList (modelId) {
  let url = 'zy/stageAudienceList/' + modelId
  return axiosJavaSet.get(url)
}
// 设置-受众等级列表
export function getCusList (modelId) {
  let url = 'zy/stageAudienceList/' + modelId
  return axiosJavaSet.get(url)
}
// 设置-编辑受众等级
// export function editCustomerStage(name, id, modelId) {
//   let url = 'zy/stage'
//   return axiosJavaSet.put(url, {
//     name,
//     id,
//     modelId
//   })
// }
//受众等级
export function editCustomerStage (data) {
  let url = 'zy/insertOrUpdateStage'
  return axiosJavaSet.post(url, data)
}
// 设置-受众属性常用非常用
export function customerAttrIsNormal (isNormal, id) {
  let url = 'zy/shopUserModelAttr/updateNormal'
  return axiosJavaSet.put(url, {
    isNormal,
    id
  })
}
// 设置-删除单一属性
export function deleteCustomerAttr (id) {
  let url = 'zy/shopUserModelAttr/del/' + id
  return axiosJavaSet.delete(url)
}
// 设置-受众属性穿梭框左侧列表
export function getCusAttrLeftList (groupId) {
  let url = 'zy/shopUserModelAttr/default/attrList'
  return axiosJavaSet.get(url, {
    params: {
      groupId
    }
  })
}
// 设置-受众事件列表
export function getCusEventList (pageNum, pageSize, groupId, name) {
  let url = 'customerEvent/searchListByPage'
  return axiosJavaSet.get(url, {
    params: {
      pageNum,
      pageSize,
      groupId,
      name
    }
  })
}
// 设置-受众事件分组列表
export function getCusEventGroupList () {
  let url = 'zy/event-group'
  return axiosJavaSet.get(url)
}
// 设置-添加事件分组
export function addCustomerEventGroup (name, modelid) {
  let url = 'zy/event-group'
  return axiosJavaSet.post(url, {
    name,
    modelid
  })
}
// 设置-编辑事件分组
export function editCustomerEventGroup (id, name, sort, modelid) {
  let url = 'zy/event-group'
  return axiosJavaSet.put(url, {
    id,
    name,
    sort,
    modelid
  })
}
// 设置-删除事件分组
export function deleteCustomerEventGroup (id) {
  let url = 'zy/event-group/' + id
  return axiosJavaSet.delete(url)
}
// 设置-添加事件
export function addCustomerEvent (
  name,
  identity,
  score,
  stageId,
  groupId,
  attr,
  stage,
  icon,
  markAttrList
) {
  let url = 'customerEvent/addCustomerEvent'
  return axiosJavaSet.post(url, {
    name,
    identity,
    score,
    stageId,
    groupId,
    attr,
    stage,
    icon,
    markAttrList
  })
}
// 设置-删除事件
export function deleteCustomerEvent (id) {
  let url = 'customerEvent/deletedCustomerEvent?id=' + id
  return axiosJavaSet.delete(url)
}
// 设置-属性排序
export function sortCustomerAttr (data, modelId) {
  let url = 'zy/shopUserModelAttr/sort/' + modelId
  return axiosJavaSet.put(url, data)
}
// 设置-属性穿梭框添加
export function attrTransAdd (attrIds, modelId) {
  let url = 'zy/shopUserModelAttr/choose'
  return axiosJavaSet.post(url, {
    attrIds,
    modelId
  })
}
// 设置-属性穿梭框删除
export function attrTransDel (attrIds) {
  let url = 'zy/shopUserModelAttr/batchDelete'
  return axiosJavaSet.post(url, {
    attrIds: attrIds
  })
}
// 设置-事件编辑之前的回显（详情）
export function detailCustomerEvent (id) {
  let url = 'customerEvent/findOne'
  return axiosJavaSet.get(url, {
    params: {
      id: id
    }
  })
}
// 设置-事件编辑
export function editCustomerEvent (
  id,
  name,
  identity,
  score,
  stageId,
  groupId,
  attr,
  stage,
  icon,
  markAttrList
) {
  let url = 'customerEvent/updataCustomerEvent'
  return axiosJavaSet.put(url, {
    id,
    name,
    identity,
    score,
    stageId,
    groupId,
    attr,
    stage,
    icon,
    markAttrList
  })
}
// 设置-事件移至分组
export function eventToGoup (groupId, ids) {
  let url = 'customerEvent/moveToGroup'
  return axiosJavaSet.post(url, {
    groupId,
    ids
  })
}
// 受众-受众新建属性列表
export function getCusAddAttrList (modelId) {
  let url = '/modelData/loadAttrList/' + modelId
  return axiosJavaSet.get(url)
}
// 受众-受众添加
export function addAudiences (modelId, data) {
  let url = 'modelData/save/' + modelId
  return axiosJavaSet.post(url, data)
}
// 受众-受众列表
export function getAudiencesList (
  page,
  limit,
  search,
  modelId,
  rowList,
  userGroupId
) {
  let url = '/zy/stores/query'
  return axiosJavaSet.post(url, {
    page,
    limit,
    search,
    modelId,
    rowList,
    userGroupId
  })
}
// 受众-获取筛选列表
export function getCusSearchList (modelId) {
  let url = '/userGroup/getSearchCondition/' + modelId
  return axiosJavaSet.get(url)
}
// 受众-保存筛选条件
export function addAudSearchCondition (name, modelId, number, query) {
  let url = '/userGroup/saveSearchCondition'
  return axiosJavaSet.post(url, {
    name,
    modelId,
    number,
    query
  })
}
// 受众-受众导出
export function getAudExportList (search, modelId, rowList, isImportIdentitys) {
  let url = '/zy/stores/export'
  return axiosJavaSet.post(url, {
    search,
    modelId,
    rowList,
    isImportIdentitys
  })
}
// 受众-获取添加的关联模型的下拉列表
export function getMyAboutModelList (modelId, identity, searchValue) {
  let url = '/zy/stores/queryAttr/' + modelId + '/' + identity
  return axiosJavaSet.get(url, {
    params: {
      searchValue
    }
  })
}
// 受众-删除受众
export function deleteAudience (modelId, id) {
  let url = 'zy/stores/delete/' + modelId + '/' + id
  return axiosJavaSet.delete(url)
}
// 设置-获取设置属性的分组列表
export function getSetAttrGroupList () {
  let url = 'zy/shopUserModelAttr/default/attrGroup'
  return axiosJavaSet.get(url)
}
// 获取终端店详情
export function getTerminalStoreDetail (modelId, id) {
  let url = '/zy/stores/detail/' + modelId + '/' + id
  return axiosJavaSet.get(url)
}
// 获取终端店 订单详情
export function getTerminalOrderDetail (modelId, id) {
  let url = '/zy/stores/detail/order/' + modelId + '/' + id
  return axiosJavaSet.get(url)
}
// 终端店详情
export function editTerminalStoreDetail (modelId) {
  let url = '/modelData/loadNormalAttrList/' + modelId
  return axiosJavaSet.get(url)
}
// 编辑终端店详情
export function updateTerminalStoreDetail (modelId, id, data) {
  let url = '/modelData/update/' + modelId + '/' + id
  return axiosJavaSet.post(url, data)
}
// 受众-受众设置列保存
export function setAudRowList (modelId, fields) {
  let url = 'zy/shopUserModelAttr/saveShowFields'
  return axiosJavaSet.post(url, {
    modelId,
    fields
  })
}
// 获取受众模型的列表显示字段
export function getAudListShowSix (modelId) {
  let url = 'zy/shopUserModelAttr/getShowFields/' + modelId
  return axiosJavaSet.get(url)
}
// 设置-属性穿梭框增删接口
export function setTransAddDel (modelId, identities) {
  let url = 'zy/shopUserModelAttr/choose'
  return axiosJavaSet.post(url, {
    modelId,
    identities
  })
}
// 标签分组列表接口
export function getTagsGroupList (modelId) {
  let url = 'tagGroup/searchList'
  return axiosJavaSet.get(url, {
    params: {
      modelId
    }
  })
}
// 添加标签分组列表接口
export function addTagsGroup (name, modelId) {
  let url = 'tagGroup/add'
  return axiosJavaSet.post(url, {
    name,
    modelId
  })
}
// 编辑标签分组名称
export function editTagsGroup (data) {
  let url = 'tagGroup/update'
  return axiosJavaSet.put(url, {
    id: data.id,
    name: data.name,
    modelId: data.modelId
  })
}
// 删除标签分组名称
export function deleteTagsGroup (id) {
  let url = 'tagGroup/delete'
  return axiosJavaSet.delete(url, {
    params: {
      id: id
    }
  })
}
// 标签列表接口
export function getTagsList (params) {
  let url = 'zy/shopUserTags/list'
  return axiosJavaSet.get(url, {
    params: params
  })
}
// 添加标签接口
export function addTags (params) {
  let url = 'zy/shopUserTags/add'
  return axiosJavaSet.post(url, params)
}
// 编辑标签名称
export function editTags (data) {
  let url = 'zy/shopUserTags/update'
  return axiosJavaSet.put(url, data)
}
// 删除标签
export function deleteTags (id) {
  let url = 'zy/shopUserTags/delete/' + id
  return axiosJavaSet.delete(url)
}
// 移动标签分组
export function moveTagsGroup (params) {
  let url = 'tagGroup/moveToGroup'
  return axiosJavaSet.post(url, params)
}
// 获取受众模型的群组列表
export function getAudGroupList (modelId, pageNum, pageSize, name, groupId) {
  let url = 'userGroup/searchListByPage'
  return axiosJavaSet.get(url, {
    params: {
      modelId,
      pageNum,
      pageSize,
      name,
      groupId
    }
  })
}
// 受众-删除受众群组
export function deleteAudienceGroup (modelId, id) {
  let url = 'userGroup/deleteUserGroup'
  return axiosJavaSet.delete(url, {
    params: {
      modelId,
      id
    }
  })
}

//静态群组 - 删除  modelId: 模型id  id: 受众主键Id  groupsId: 静态群组Id
export function deleteStaticGroup (modelId, id, groupsId) {
  const url = '/userGroup/deleteBymodelId'
  return axiosJavaSet.post(url, {
    modelId,
    id,
    groupsId
  })
}

//删除 标签   modelId: 模型id  id: 受众主键Id
export function deleteByTags (modelId, id, tagId) {
  const url = '/userGroup/deleteByTags'
  return axiosJavaSet.post(url, {
    modelId,
    id,
    tags: tagId
  })
}

// 批量删除 静态 群组
export function batchDeleteStaticGroup (modelId, rowList, search, userGroupId) {
  const url = '/userGroup/removeAudiencesFromGroupBySearch'
  return axiosJavaSet.post(url, {
    modelId,
    rowList,
    search,
    userGroupId
  })
}

// 获取受众模型的高级查询事件限制属性字典类型数据
export function getAudHigSearDicList (
  eventIdentity,
  attrIdentity,
  name,
  modelId
) {
  let url = 'customerEvent/searchDictionaryList'
  return axiosJavaSet.get(url, {
    params: {
      eventIdentity,
      attrIdentity,
      name,
      modelId
    }
  })
}
// 获取受众群组分组列表
export function getAudGroupGroupList (modelId, name) {
  let url = 'userGroupGroup/searchList'
  return axiosJavaSet.get(url, {
    params: {
      modelId,
      name
    }
  })
}
// 添加受众群组分组
export function addAudGroupGroup (data) {
  let url = 'userGroupGroup/add'
  return axiosJavaSet.post(url, data)
}
// 编辑受众群组分组
export function editGroupType (data) {
  let url = 'userGroupGroup/update'
  return axiosJavaSet.put(url, data)
}
// 编辑受众群组分组
export function deleteAudGroupType (id) {
  let url = 'userGroupGroup/delete'
  return axiosJavaSet.delete(url, {
    params: {
      id: id
    }
  })
}
// 移动受众群组分组
export function confirmChooseGroupType (data) {
  let url = 'userGroup/moveToGroup'
  return axiosJavaSet.post(url, data)
}
// 获取受众标签列表
export function getAudTagList (modelId, name, page, limit) {
  let url = 'zy/shopUserTags/list'
  return axiosJavaSet.get(url, {
    params: {
      modelId: modelId,
      name: name,
      page: page,
      limit: limit
    }
  })
}
// 批量打标签或移除标签
export function batchAddOrRemoveTags (params) {
  let url = 'zy/shopUserTags/batchAddOrRemoveTags'
  return axiosJavaSet.post(url, params)
}
// 受众-添加群组
export function addAudGroup (modelId, name, type, search, groupId) {
  let url = 'userGroup/addUserGroup'
  return axiosJavaSet.post(url, {
    modelId: modelId,
    name: name,
    type: type,
    search: search,
    groupId: groupId
  })
}
// 获取受众群组详情
export function getAudGroupDetail (
  userGroupId,
  createStart,
  createEnd,
  page,
  limit,
  isShowCustomer,
  rowList,
  modelId,
  search,
  type
) {
  let url = 'userGroup/findOne'
  return axiosJavaSet.post(url, {
    userGroupId,
    createStart,
    createEnd,
    page,
    limit,
    isShowCustomer,
    rowList,
    modelId,
    search,
    type
  })
}
// 受众修改群组
export function audEditGroup (data) {
  let url = 'userGroup/updateUserGroup'
  return axiosJavaSet.put(url, data)
}
// 受众静态群组追加客户
export function addAudGroupDetail (id, modelId, search) {
  let url = 'userGroup/addCustomer'
  return axiosJavaSet.post(url, {
    id: id,
    modelId: modelId,
    search: search
  })
}
// 获取指定模型分析维度和群组
export function getAudGroupAndDimension (modelId) {
  let url = 'anlys/dimensionsAndGroup/' + modelId
  return axiosJavaSet.get(url)
}
// 资源-产品管理
// 3.产品查询列表
export function getProductList (params) {
  let url = 'manage/product/query'
  return axiosJavaSet.post(url, params)
}
// 2.获取产品模型展示列
export function getProductModelIdFields (modelId) {
  let url = 'zy/shopUserModelAttr/getShowFields/' + modelId
  return axiosJavaSet.get(url)
}
// 1.获取产品模型
export function getProductModel (typeId) {
  let url = 'audiencesModel/searchModelList'
  return axiosJavaSet.get(url, {
    params: {
      typeId: typeId
    }
  })
}
// 4.获取数据回显
export function getSaveDataShow (modelId, code) {
  let url = 'manage/product/queryById'
  return axiosJavaSet.get(url, {
    params: {
      modelId: modelId,
      id: code
    }
  })
}
// 5.添加产品数据
export function addResourceProduct (params) {
  let url = 'manage/product/add'
  return axiosJavaSet.post(url, params)
}
// 6.修改产品信息
export function updateResourceProduct (params) {
  let url = 'manage/product/update'
  return axiosJavaSet.post(url, params)
}
// 7.删除产品信息
export function deleteResourceProduct (modelId, productId) {
  let url = 'manage/product/del/' + modelId + '/' + productId
  return axiosJavaSet.delete(url)
}
// 导出订单文件
export function getOrderExport (params) {
  let url = '/zy/order/export'
  return axiosJavaSet.get(url, {
    params: params
  })
}
